import React from 'react';
import SliderBlogpost from '../swiper/sliderBlog';

export default function ({ highlightsfeed, eleRef }) {
    return (

<section className="main_container_block_feeds writefus">
<div className="main_block_container_feed">
  <div className="block_container_feed_heading_text R15_61" role='heading' tabIndex={0} aria-label={highlightsfeed.title}>
     {highlightsfeed.title?highlightsfeed.title:''}
   </div>
   <div className="content-div-box-artical">
      <div className="fertil_background_main_view">
          <div className="blog_posted_background_pic"> 
              <div className="blogs_posted_communitys_view">
                   <div className="content-div_view_blog_post_bg">
                       <SliderBlogpost page={"dr-carousel-unit"} data={highlightsfeed} eleRef={eleRef}/>
                   </div>
                   <div className="breastfeeding_bg_content desktop_view_btn_blogss">
                   <a href='https://parenting.firstcry.com/write-for-us/' tabIndex={0} aria-label='view details to know more'>
                       <div className="M16_21 fc_mr_my-20 fc_text_center">
                        View Details to Know More 
                        </div>
                        </a>
                       <div className="ovulation_fertic_btn_group_join_common fc_pd_mb-30">
                        <a href='https://parenting.firstcry.com/write-for-us/create-post' tabIndex={0} aria-label='start writing now'>
                          <button className="M15_fd5387 mr_b12 gtm-start-writing" type="button" tabIndex={-1} aria-hidden="true"> 
                             <div className="icon fc_pd_px icon3dot" data-icon-font="H"> </div> 
                             Start Writing Now </button>
                             </a>
                       </div>
                   </div>
              </div>   
          </div>
      </div>
   </div>
</div>
</section>

    )
}
